/**
 * Created by rathompson on 8/16/23
 * File: RestrictedAccessScreen.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import React, { useCallback, useContext } from 'react'
import NoDataScreen from '../noDataScreen/NoDataScreen'
import {
  HEADING_ACCESS_DENIED,
  LABEL_PRODUCT_IS_IP_RESTRICTED,
  LABEL_CONTACT_SUPPORT_ADMIN, LABEL_NO_ACCESS_RESET_DESC,
} from '../../constants/LabelConstants'
import { Body, InvalidPermissionsSVG, Link } from '@panwds/react-ui'
import StringTemplate from '../../utils/StringTemplate'
import GlobalContext from '../../context/GlobalContext'
import { getFrameworkServiceUrl } from '../../utils/Sparky'
import { HUB_LANDING_PATH } from '../../constants/GlobalConstants'

const RestrictedAccessScreen: VFC<any> = () => {

  const { treeReducer } = useContext(GlobalContext)
  const { selectedTreeNode } = treeReducer

  const onHubClick = useCallback(() => {
    const hubUrl = getFrameworkServiceUrl('app_portal')
    const url = new URL(HUB_LANDING_PATH, hubUrl)
    url.searchParams.append('tsg_id', selectedTreeNode?.id)
    window.location.href = url.toString()
  }, [selectedTreeNode?.id])

  return (
    <div className='cm-flex cm-flex-row cm-flex-1 cm-w-full cm-h-full'>
      <NoDataScreen
        style={{ height: '100%', width: '100%' }}
        graphic={<InvalidPermissionsSVG width={90} height={90} />}
        heading={HEADING_ACCESS_DENIED}
        actions={(
          <div className='cm-flex cm-flex-col cm-gap-2 cm-w-min'>
            <Body appearance='secondary'>{LABEL_PRODUCT_IS_IP_RESTRICTED}</Body>
            <div className='cm-w-max'>
              <Body appearance='secondary'>{LABEL_CONTACT_SUPPORT_ADMIN}</Body>
              <Body appearance='secondary'>{StringTemplate(LABEL_NO_ACCESS_RESET_DESC, <Link onClick={onHubClick}>Hub</Link>)}</Body>
            </div>
          </div>
        )}
      />
    </div>
  )
}

export default RestrictedAccessScreen
